<script lang="ts">
	import Navbar from "./components/Navbar.svelte"
	import Footer from "./components/Footer.svelte"
	import Start from "./components/Start.svelte"
	import Equation from "./components/Equation.svelte"
	import Question from "./components/Question.svelte";
	import Answer from "./components/Answer.svelte";
	import Result from "./components/Result.svelte";

	import { shuffle } from "./utils";

	import { onMount } from "svelte";
	import { fade } from "svelte/transition"

	export let quiz: TQuiz[]
	export let result: { [key: string]: TResult }
	export let score: { [key: string]: number }

	let order: number[]

	let currentQuestion: number
	let currentText: String
	let questionText: String
	let answers: {[key: string]: string[]}

	let userResult: string 
	let isStart: boolean = false
	let isEnd: boolean = false
	let isEquation: boolean = false

	let audioLoadedMetadata: boolean = false
	let audioIcon = `assets/music_on.svg`

	let toggleAudio = () => {}
	let switchAudio = () => {}

	const start = () => {
		order = shuffle(Array.from({length: quiz.length}, (_, i) => i))
		currentQuestion = 0
		currentText = `${currentQuestion+1}/${quiz.length}`

		questionText = quiz[order[currentQuestion]].question
		answers = quiz[order[currentQuestion]].answers

		userResult = ""
		isStart = true
		isEnd = false
	}

	const toggleEquation = () => {
		isEquation = !isEquation
	}

	const next = (result: string[]) => {
		result.forEach(r => score[r] += 1)

		currentQuestion += 1
		currentText = `${currentQuestion+1}/${quiz.length}`

		const elementType = (document.activeElement as HTMLInputElement).type;
		if (elementType === "submit") {
			setTimeout(() => {
				(document.activeElement as HTMLInputElement).blur()
			}, 200)
		}

		if (currentQuestion < quiz.length) {
			questionText = quiz[order[currentQuestion]].question
			answers = quiz[order[currentQuestion]].answers
		}
		else {
			userResult = Object.keys(score).reduce((a, b) => score[a] > score[b] ? a : b);
			isEnd = true
		}
	}

	const reset = () => {
		isStart = false
   		Object.keys(score).forEach(key => score[key] = 0)
	}

	onMount(() => {
		const audio: HTMLAudioElement = document.querySelector("audio")
		audio.addEventListener("loadedmetadata", () => {
			audioLoadedMetadata = true
			let playResult = audio.play()
			if (playResult !== undefined) {
				playResult.catch(error => {
					audioIcon = `assets/music_off.svg`
				});
			}
		})

		toggleAudio = () => {
			if (audio.paused) {
				audio.play()
				audioIcon = `assets/music_on.svg`
			} else {
				audio.pause()
				audioIcon = `assets/music_off.svg`
			}
		}

		switchAudio = (play: boolean = true) => {
			if (play) {
				audio.play()
				audioIcon = `assets/music_on.svg`
			} else {
				audio.pause()
				audioIcon = `assets/music_off.svg`
			}
		}
	})

</script>

<svelte:head>
    <link rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=IBM+Plex+Sans+Thai">
	<meta property="og:url"                content="" />
	<meta property="og:type"               content="article" />
	<meta property="og:title"              content="SPACETH.CO + DGERRARD | สมการความรักของคุณคือสมการอะไร?" />
	<meta property="og:description"        content="" />
	<meta property="og:image"              content="/assets/cover/cover.png" />
</svelte:head>

<style>

    :global(body) {
        background: linear-gradient(0deg, #092931, #461728);
    	background-size: 400% 400%;
		animation: background-gradient 10s infinite linear;
		background-repeat: no-repeat;
    	background-attachment: fixed;
        color: whitesmoke;

		width: 100%;
		min-height: 100vh;
		border: 0;
		padding: 0;
		margin: 0;

		overflow-x: hidden;

		display: flex;
		flex-direction: column;
		align-items: center;
		text-decoration: none;

		font-family: "Sukhumvit set", "IBM Plex Sans Thai", sans-serif;
		font-weight: 300;
		font-size: 1em;
    }

	@-webkit-keyframes background-gradient {
	    0%{background-position:0% 50%}
	    50%{background-position:100% 50%}
	    100%{background-position:0% 50%}
	}

	@keyframes background-gradient {
	    0%{background-position:0% 50%}
	    50%{background-position:100% 50%}
	    100%{background-position:0% 50%}
	}

	:global(button) {
        display: inline-block;
        padding: 0.35em 1.2em;
        margin: 0 0.5em 1em;
        border: 0.1em solid #ddd;
        border-radius: 0.2em;
        text-decoration: none;
        font-weight: 300;
        color:#ddd;
        background-color: transparent;
        text-align:center;
        transition: all 0.6s;
    }

	:global(h1) {
		font-weight: 300;
		text-align: center;
		color: #ddd;
	}

	main {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		min-height: calc(100vh - 80px);
		overflow-x: hidden;
	}

	.video-wrapper {
		position: fixed;
		overflow: hidden;
		min-width: 100%;
		min-height: 100vh;
		z-index: -1;
		margin: 0;
		overflow: hidden;
		margin: 0;
		opacity: 0.6;
	}

	video {
		min-width: 100%;
		min-height: 100vh;
		overflow: hidden;
		object-fit: cover;
	}

	audio {
		z-index: 999;
	}

	#play-icon {
		position: absolute;
		z-index: 999;
		width: 1.5em;
		margin: 1em;
		margin-top: 1.2em;
		right: 1em;
	}

	@media (max-width: 640px) {
		main {
			max-width: none;
		}

		:global(h1) {
			font-size: 1.2em;
		}

		:global(h3) {
			font-size: 1em;
		}

		#play-icon {
			right: 0.25em;
			margin-top: 1em;
		}
	}

</style>

<audio
	src="assets/audio.m4a"
	id="audio"
	loop
	playsinline
	autoplay
>
	<track kind="audio" />
</audio>
{#if audioLoadedMetadata}
	<img src={audioIcon} alt="mute" id="play-icon" on:click={toggleAudio}>
{/if}
<Navbar />
{#if !isStart || isEnd}
<div class="video-wrapper">
	<video 
			id="video"
			autoplay
			muted
			loop
			playsinline
			out:fade
		>
			<source src="assets/magic-small.mp4" type="video/mp4">
		</video>
</div>
{/if}
{#if !isStart}
	{#if !isEquation}
	<main>
		<Start start={start} toggleEquation={toggleEquation} switchAudio={switchAudio}/>
	</main>
	{:else}
		<Equation toggleEquation={toggleEquation}/>
	{/if}
{:else}
	{#if !isEnd}
		<main>
			{#key answers}
				<div in:fade>{currentText}</div>
				<Question question={questionText} />
				<Answer answers={answers} next={next}/>
			{/key}
		</main>
	{:else}
		<Result result={result[userResult]} reset={reset} name={userResult}/>
	{/if}
{/if}
<Footer />